<template>
  <div id="award-type-create" class="edit-dialog-container">
    <v-card class="edit-dialog-card elevation-24">
      <!-- Professional Header -->
      <div class="edit-dialog-header">
        <div class="header-left">
          <v-icon size="36" color="white" class="header-icon-badge"
            >mdi-pencil-circle</v-icon
          >
          <div class="header-text-section">
            <h2 class="header-title">{{ PageTitle }}</h2>
            <p class="header-subtitle">
              Update judging criteria question details
            </p>
          </div>
        </div>
        <div class="header-right">
          <v-btn
            icon
            dark
            @click="closePrompt"
            class="header-action-btn"
            v-tooltip.left="'Close'"
          >
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Content Area -->
      <v-sheet
        id="scrolling-techniques-7"
        class="edit-dialog-content-sheet overflow-y-auto"
        max-height="600"
      >
        <v-card-text class="edit-dialog-body-content">
          <!-- Loading State -->
          <div v-if="LoadingFlag" class="text-center py-12">
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <p class="mt-6 text-h6 primary--text font-weight-600">
              Loading question details...
            </p>
          </div>

          <!-- Form Content -->
          <div v-if="!LoadingFlag">
            <div class="form-helper-text">
              <v-icon small color="primary" class="mr-2"
                >mdi-information-outline</v-icon
              >
              <span
                ><span class="text-danger">*</span> indicates required
                field</span
              >
            </div>

            <v-form
              ref="form1"
              v-model="valid1"
              lazy-validation
              v-on:submit.prevent="confirmAlert"
            >
              <v-row wrap class="form-fields-grid">
                <!-- Questions Chars Count -->
                <!-- Questions Text -->
                <v-col cols="12" md="12">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-text-box</v-icon
                      >
                      <span><span class="text-danger">*</span> Questions</span>
                    </label>
                    <v-textarea
                      v-model="QuestionsText"
                      placeholder="Questions"
                      :rules="QuestionsTextRules"
                      required
                      outlined
                      dense
                      class="form-control-modern"
                    ></v-textarea>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-counter</v-icon
                      >
                      <span
                        ><span class="text-danger">*</span> Questions Chars
                        Count</span
                      >
                    </label>
                    <v-text-field
                      v-model="QuestionsCharsCount"
                      placeholder="Questions Chars Count"
                      :rules="QuestionsCharsCountRules"
                      type="number"
                      min="1"
                      required
                      outlined
                      dense
                      class="form-control-modern"
                      solo
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Questions Attachment Maximum Count -->
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field-wrapper">
                    <label class="form-field-label">
                      <v-icon small class="mr-2" color="primary"
                        >mdi-file-multiple</v-icon
                      >
                      <span
                        ><span class="text-danger">*</span> Attachment Maximum
                        Count</span
                      >
                    </label>
                    <v-text-field
                      v-model="QuestionsAttachmentMax"
                      placeholder="Questions Attachment Maximum Count"
                      :rules="QuestionsAttachmentMaxRules"
                      type="number"
                      min="1"
                      required
                      outlined
                      dense
                      class="form-control-modern"
                      solo
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>

              <!-- Action Buttons -->
              <v-row wrap class="form-actions-row mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    @click="closePrompt"
                    color="grey"
                    elevation="4"
                    rounded
                    height="48"
                    min-width="160"
                    class="cancel-btn"
                  >
                    <v-icon left>mdi-close</v-icon>
                    CANCEL
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="confirmAlert"
                    :loading="SubmitFlag"
                    color="#8950fc"
                    elevation="6"
                    rounded
                    height="48"
                    min-width="160"
                    class="submit-btn white--text mr-3"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    SUBMIT
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-sheet>

      <!-- Footer -->
      <v-divider></v-divider>
      <v-card-actions class="edit-dialog-footer pa-4">
        <v-spacer />
        <p class="text-caption text-grey-1">
          All fields marked with <span class="text-danger">*</span> are required
        </p>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    editRecordPrompt: {
      required: true,
      type: Boolean,
    },
    CriteriaQuestionsId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SubmitFlag: false,

      UploadFlag: false,
      ResultFlag: false,

      JudgingCriteriaRules: [(v) => !!v || "Judging Criteria is required"],
      JudgingCriteria: "",
      JudgingCriteriaOptions: [],

      QuestionsCharsCountRules: [
        (v) => !!v || "Questions Chars Count is required",
        (v) => (v && v >= 1) || "Questions Chars Count minimum 1",
      ],
      QuestionsCharsCount: "",

      QuestionsAttachmentMaxRules: [
        (v) => !!v || "Questions Attachment Maximum Count is required",
        (v) =>
          (v && v >= 1) ||
          "Questions Attachemnt Maximum Count must be minimum 1",
      ],
      QuestionsAttachmentMax: "",

      QuestionsTextRules: [(v) => !!v || "Questions is required"],
      QuestionsText: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var CriteriaQuestionsId = this.CriteriaQuestionsId;
        console.log({ CriteriaQuestionsId });

        this.getJudgingCriteriaOptions();
        this.getTableRecords();
      }
    },
    JudgingCriteriaOptions: function () {
      console.log("watch JudgingCriteriaOptions");
      this.JudgingCriteriaOptionsLoading = false;
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "judging_criteria_question",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.LoadingFlag = false;
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },
    getJudgingCriteriaOptions() {
      console.log("getJudgingCriteriaOptions called");
      var selectbox1_source = "JudgingCriteria";
      var selectbox1_destination = "JudgingCriteriaOptions";
      var selectbox1_url = "api/judging-criteria/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var CriteriaQuestionsId = this.CriteriaQuestionsId;
      console.log({ CriteriaQuestionsId });

      if (CriteriaQuestionsId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/judging-criteria-questions/show";
        var upload = {
          UserInterface: 1,
          CriteriaQuestionsId: CriteriaQuestionsId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.JudgingCriteria = records.JudgingCriteriaId;
              thisIns.QuestionsText = records.JudgingCriteriaQuestionsText;
              thisIns.QuestionsCharsCount =
                records.JudgingCriteriaQuestionsCharsCount;
              thisIns.QuestionsAttachmentMax =
                records.JudgingCriteriaQuestionsAttachmentMax;

              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award Type details not found.";
        console.log("error=" + message);
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.SubmitFlag = true;
      this.ResultFlag = false;

      var upload = {
        UserInterface: 1,
        CriteriaQuestionsId: this.CriteriaQuestionsId,
        JudgingCriteria: this.JudgingCriteria,
        QuestionsCharsCount: this.QuestionsCharsCount,
        QuestionsAttachmentMax: this.QuestionsAttachmentMax,
        QuestionsText: this.QuestionsText,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/judging-criteria-questions/update";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.SubmitFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.ResultFlag = true;
            thisIns.closePrompt();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
        });
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
.edit-dialog-container {
  width: 100%;
  height: 100%;
}

/* ============================================
   DIALOG CARD
   ============================================ */
.edit-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: dialogSlideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 95vh;
  display: flex;
  flex-direction: column;
}

/* ============================================
   DIALOG HEADER
   ============================================ */
.edit-dialog-header {
  background: linear-gradient(135deg, #8950fc 0%, #1d73b9 100%);
  padding: 24px 28px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }

  .header-left {
    display: flex;
    align-items: center;
    z-index: 1;
    animation: slideInLeft 0.6s ease-out;
    gap: 16px;
  }

  .header-icon-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: pulse 2s ease-in-out infinite;
  }

  .header-text-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .header-right {
    display: flex;
    gap: 8px;
    z-index: 1;
  }

  .header-title {
    font-size: 1.35rem;
    font-weight: 800;
    margin: 0;
    letter-spacing: 0.5px;
    line-height: 1.2;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .header-subtitle {
    font-size: 0.8rem;
    opacity: 0.92;
    margin: 6px 0 0 0;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: rgba(255, 255, 255, 0.95);
  }
}

.header-action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

  &:hover {
    transform: scale(1.15) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }

  &:active {
    transform: scale(0.95) !important;
  }
}

/* ============================================
   DIALOG CONTENT
   ============================================ */
.edit-dialog-content-sheet {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%) !important;
  padding: 0 !important;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(137, 80, 252, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(137, 80, 252, 0.3);
    border-radius: 10px;

    &:hover {
      background: rgba(137, 80, 252, 0.5);
    }
  }
}

.edit-dialog-body-content {
  padding: 28px !important;
  animation: fadeIn 0.6s ease-out 0.2s both;
}

/* ============================================
   FORM HELPER TEXT
   ============================================ */
.form-helper-text {
  display: flex;
  align-items: center;
  background: linear-gradient(
    135deg,
    rgba(137, 80, 252, 0.08) 0%,
    rgba(29, 185, 84, 0.08) 100%
  );
  border-left: 4px solid #8950fc;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-fields-grid {
  margin-bottom: 20px;
}

.form-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin: 0;

  .v-icon {
    color: #8950fc;
  }

  .text-danger {
    color: #e74c3c;
    font-weight: 800;
  }
}

.form-control-modern {
  ::v-deep {
    .v-input__control {
      .v-input__slot {
        background: white !important;
        border-radius: 8px !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid rgba(137, 80, 252, 0.2) !important;

        &:hover {
          border-color: rgba(137, 80, 252, 0.4) !important;
        }

        &:focus,
        &:active {
          border-color: #8950fc !important;
          box-shadow: 0 0 0 3px rgba(137, 80, 252, 0.1);
        }
      }

      .v-input__append-inner {
        .v-icon {
          color: #8950fc !important;
          font-size: 18px !important;
        }
      }
    }

    .v-text-field__prefix {
      color: #8950fc !important;
      font-weight: 700;
      margin-right: 8px;
    }

    .v-input__hint {
      color: #999 !important;
      font-size: 12px !important;
    }

    &.v-text-field--outlined {
      .v-input__control {
        .v-input__slot {
          background: white !important;
          border: 1px solid rgba(137, 80, 252, 0.2) !important;

          input {
            color: #333;
            font-weight: 500;
          }

          textarea {
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.form-actions-row {
  padding-top: 16px;
  border-top: 1px solid rgba(137, 80, 252, 0.1);
}

.submit-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(137, 80, 252, 0.25) !important;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(137, 80, 252, 0.4) !important;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.cancel-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;

  &:hover {
    transform: translateY(-2px);
    background: #f0f0f0 !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
  }

  &:active {
    transform: translateY(0);
  }
}

.edit-dialog-footer {
  background: linear-gradient(90deg, #f9fafb 0%, #ffffff 100%);
  border-top: 1px solid rgba(137, 80, 252, 0.1);
  padding: 12px 24px !important;

  p {
    margin: 0;
    color: #666;
  }
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  50% {
    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 960px) {
  .edit-dialog-header {
    flex-direction: column;
    text-align: center;
    align-items: center !important;

    .header-left {
      justify-content: center;
      margin-bottom: 12px;
    }

    .header-right {
      width: 100%;
      justify-content: flex-end;
    }

    .header-title {
      font-size: 1.1rem;
    }

    .header-subtitle {
      font-size: 0.8rem;
    }
  }

  .edit-dialog-body-content {
    padding: 20px !important;
  }

  .form-fields-grid {
    row-gap: 16px;
  }
}

@media (max-width: 600px) {
  .edit-dialog-card {
    max-height: 97vh;
    max-width: 98vw;
  }

  .edit-dialog-header {
    padding: 16px !important;

    .header-left {
      flex-direction: column;
      text-align: center;
    }

    .header-icon-badge {
      width: 48px;
      height: 48px;
    }

    .header-title {
      font-size: 1rem;
    }

    .header-subtitle {
      display: none;
    }

    .header-right {
      margin-top: 12px;
    }
  }

  .edit-dialog-body-content {
    padding: 16px !important;
  }

  .form-field-label {
    font-size: 12px;
  }

  .submit-btn,
  .cancel-btn {
    width: 100%;
    margin-bottom: 8px !important;
  }

  .form-actions-row {
    .v-col {
      flex-direction: column;
    }
  }
}

::v-deep .v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

::v-deep .v-card {
  box-shadow: 0 4px 20px rgba(137, 80, 252, 0.1) !important;
}

.text-danger {
  color: #e74c3c !important;
  font-weight: 800;
}

.text-grey-1 {
  color: #999 !important;
}
</style>
